import React from "react";
import { useSelector } from "react-redux";
import ConfirmDialog from "../dialog/confirmDialog";

export default function ModalTransferList({
  handleClose,
  open,
  art,
  handleConfirmed,
}) {
  const loading = useSelector((state) => state.art.requestAdhesion.isFetching);

  return (
    <ConfirmDialog
      open={open}
      handleClose={handleClose}
      handleConfirm={handleConfirmed}
      title="Adhesión a ART"
      text={
        <span>
          ¿Está seguro que quiere adherirse a la ART <b>{art}</b>?
        </span>
      }
      loading={loading}
      cancelText="No"
      confirmText="Sí"
    />
  );
}
